/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import flatpickr from 'flatpickr';
import {forEach as _forEach} from 'lodash';

const CONFIG = {
  dateFormat: 'm/d/Y',
  mainSelector: '.js-init-date-picker',
  clearSelector: '.js-clear-date',
  altInput: true,
  altFormat: 'm/d/Y',
};

const getClearElement = instance => {
  if (instance._clearElement) {
    return instance._clearElement;
  }
  instance._clearElement =
    instance.element.parentNode.querySelector(CONFIG.clearSelector);
  return instance._clearElement;
};

const toggleClearElement = (selectedDates, dateStr, instance) => {
  const classAction = dateStr ? 'remove' : 'add';
  getClearElement(instance).classList[classAction]('invisible');
};

export default config => {
  Object.assign(CONFIG, config);
  const elements = document.querySelectorAll(
    CONFIG.mainSelector + ':not(.flatpickr-input)'
  );
  let datepickers = [];

  _forEach(elements, item => {
    if (item.classList.contains('js-date-range')) {
      Object.assign(CONFIG, {mode: 'range'});
    }
    datepickers.push(flatpickr(item, {
      ...CONFIG,
      onChange: toggleClearElement,
      onReady: toggleClearElement,
      appendTo: item.hasAttribute('data-append-here') ?
        item.parentNode : undefined,
    }));
  });

  if (!Array.isArray(datepickers)) {
    datepickers = [datepickers];
  }

  datepickers.forEach(datepicker => {
    getClearElement(datepicker).addEventListener('click',
      () => {
        datepicker.setDate('');
        toggleClearElement([], '', datepicker);
      }
    );
  });
};
